// extracted by mini-css-extract-plugin
export default {"FormRadioButton":"styles_FormRadioButton__DNOTu"};